export default __webpack_public_path__ + "static/media/info.300654ad.svg";